import * as logMessageTypes from '../../consts/log/logMessageTypes';
import iccMarketService from '../../services/icc/iccMarketService';
import log from '../../services/logger/log';
import server from '../../services/server/server';
import appConfig from '../appConfig';
import configTemplate from './advanceDiagnosticConfig.json';
import * as advanceDiagnosticScreenSteps from './advanceDiagnosticScreenSteps';

export let advanceDiagnosticConfig = configTemplate.deviceConfigs;

export const initAdConfig = async () => {
    try {
        const data = await fetchExternalConfig();
        const {deviceConfigs} = data || {};

        if (deviceConfigs) {
            advanceDiagnosticConfig = deviceConfigs;
        }
    } catch (e) {
        log.error(`adConfig: fetchExternalAdConfig, error: ${e}`, {logMessageType: logMessageTypes.ICC});
    }

    //convert string flow to object flow
    advanceDiagnosticConfig.forEach((x) => {
        x.defaultFlow = getFlowByName(x.defaultFlow);
        x.config?.forEach((y) => {
            y.flow = getFlowByName(y.flow);
        });
    });
};

const getFlowByName = (name) => {
    switch (name) {
        case 'SUCCESS_FLOW':
            return advanceDiagnosticScreenSteps.SUCCESS_FLOW;
        case 'FWU_CHECK_AND_RESET_FLOW':
            return advanceDiagnosticScreenSteps.FWU_CHECK_AND_RESET_FLOW;
        case 'ELIGIBILITY_CHECK':
            return advanceDiagnosticScreenSteps.MARKET_FLOW;
        case 'FWU_CHECK_AND_ELIGIBILITY_FLOW':
            return advanceDiagnosticScreenSteps.FWU_CHECK_AND_MARKET_FLOW;
        case 'FWU_CHECK_AND_ADAPTOR_MSG_FLOW':
            return advanceDiagnosticScreenSteps.FWU_CHECK_AND_ADAPTOR_MSG_FLOW;
        default:
            return advanceDiagnosticScreenSteps.SUCCESS_FLOW;
    }
};

const fetchExternalConfig = async () => {
    const externalConfigUrl = appConfig.getAdConfigFileNamePath();

    if (!externalConfigUrl) return null;

    const externalConfigLink = await iccMarketService.getMediaUrl({
        mediaNameList: externalConfigUrl,
    });

    const externalConfigPath = externalConfigLink?.[0]?.url;

    if (!externalConfigPath) return null;

    const {data} = await server.get(externalConfigPath);

    return data;
};
